module.exports = __webpack_public_path__ + "static/media/blog_img3.eb42a8cf.jpg";